import { Component, OnInit, Input } from '@angular/core';
import { BuyerInformation } from '../../models/credit-transaction';
import { BuyerInformationService } from '../../services/buyer-information.service';
import { TokenServiceService } from '../../services/token-service.service';
import { Payment } from '../../models';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { EmailValidator } from '../../tools/email-validator';
import { BUYER_INFORMATION_VALIDATIONS } from '../../core/constants/Errors';

@Component({
  selector: 'app-buyer-information',
  templateUrl: './buyer-information.component.html',
  styleUrls: ['./buyer-information.component.scss'],
})
export class BuyerInformationComponent implements OnInit {
  buyerInformation: BuyerInformation;
  @Input() info: Payment;
  @Input() buyerInfoControl?: any;
  form: FormGroup;
  errorsMessages = BUYER_INFORMATION_VALIDATIONS;

  constructor(
    private readonly buyerInformationService: BuyerInformationService,
    private readonly tokenServiceService: TokenServiceService,
    private readonly formBuilder: FormBuilder,
  ) {
    this.form = this.formBuilder.group({
      cellPhone: ['', Validators.compose([
        Validators.required,
        Validators.maxLength(30),
        Validators.minLength(8),
        Validators.pattern('^[0-9]*$'),
      ])],
      email: ['', Validators.compose([
        Validators.required,
        Validators.maxLength(150),
        Validators.minLength(10),
        EmailValidator.isValid
      ])],
    });
  }

  ngOnInit() {
    this.buyerInformation = new BuyerInformation();
  }

  saveBuyerInformation() {
    const tokenDecode = this.tokenServiceService.getAndDecodeToken();
    this.buyerInformation = this.form.value;
    const data = {
      correo: this.buyerInformation.email,
      referencia: tokenDecode.ORDER_REFERENCE,
      valor: tokenDecode.ORDER_AMOUT,
      metodo: this.info.code.toString(),
      telefono: this.buyerInformation.cellPhone,
      orderCode: tokenDecode.ORDER_CODE.toString(),
    };
    this.buyerInformationService.saveBuyer(data).subscribe(result => {
    });
  }
  /**
   * 
   * @description {isControlReadOnly} function to check if form fields are read-only
   * @param controlName 
   * @returns 
  */
  isControlReadOnly(controlName: string): boolean {
    const readOnlyControl = this.buyerInfoControl.find(m => m.formControl === controlName);
    return readOnlyControl ? readOnlyControl.readOnly : false;
  }

}
